import  { createApi,fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { BaseURL } from "../../Essentials/variables";

const rdsesApi=createApi({
    reducerPath:'rdses',
    baseQuery:fetchBaseQuery({
        baseUrl:BaseURL
    }),
    endpoints(builder){
        return{
            fetchRdses: builder.query({
                query:(data)=>{
                    console.log(data);
                    return{
                        url:`/rdsecount`,
                        params:{
                            state:data.state,
                            district:data.district
                        },
                        method:'GET'
                    }
                }
            })
        }
    }
})

export const {
//    useFetchDealersQuery ,useUpdateDealerMutation
  useFetchRdsesQuery
} = rdsesApi;
export {rdsesApi}